import { Component } from "react";
import TSSMyTask from "../../components/TTS/TSSMyTask";
import AllLexicon from "../../components/TTS/AllLexicon";


class TSSMyTaskIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            height: window.innerHeight,
        }
    }
    componentDidMount() {
        let userExists = localStorage.getItem('userExists');
        if (!userExists) {
            console.log('Access Denied');
            this.props.history.push('/');
        }
    }
    updateDimensions = () => {
        try {
            this.setState(
                { width: window.innerWidth, height: window.innerHeight });
        } catch (error) {
            this.setState({ error: error });
        }
    };

    render() {
        let pathname = window.location.pathname
        if(pathname === '/TTSMyTask'){
        if (this.state.width >= 600 && this.state.width <= 1000) {
            return (<TSSMyTask customWidth={this.state.width} customHeight={this.state.height} />)
        } else if (this.state.width > 1000) {
            return (<TSSMyTask customWidth={this.state.width} customHeight={this.state.height} />)
        }
    }
    else if(pathname === '/AllLexiconFile'){
        if (this.state.width >= 600 && this.state.width <= 1000) {
            return (<AllLexicon customWidth={this.state.width} customHeight={this.state.height} />)
        } else if (this.state.width > 1000) {
            return (<AllLexicon customWidth={this.state.width} customHeight={this.state.height} />)
        }
    }
    }
}
export default TSSMyTaskIndex    